import { ChangeDetectionStrategy, Component, Inject, LOCALE_ID, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Utils } from '@klickdata/core/util';
import { CustomFieldOption } from '../custom-field.model';
import { customFieldsBase } from '../custom-fields-base';

@Component({
    selector: 'app-custom-fields-checkbox-type',
    templateUrl: './custom-fields-checkbox-type.component.html',
    styleUrls: ['./custom-fields-checkbox-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldsCheckboxTypeComponent extends customFieldsBase implements OnInit {
    @Input() customFieldForm: FormGroup;
    Utils = Utils;
    public localeId: string;
    constructor(protected cdr: ChangeDetectorRef, @Inject(LOCALE_ID) localeId: string) {
        super(cdr, localeId);
        this.localeId = localeId;
    }
    ngOnInit(): void {
        super.ngOnInit();
        if (!this.customFieldForm.value.value) {
            this.customFieldForm.get('value').patchValue([]);
        }
    }

    getCheckedOption(option: CustomFieldOption): boolean {
        if (!Array.isArray(this.customFieldForm.value.value)) return false;
        if (Utils.isEmpty(this.customFieldForm.value.value)) return false;
        return this.customFieldForm.value.value?.includes(option.id);
    }
    updateValue(status: boolean, option: CustomFieldOption) {
        const values = Array.isArray(this.customFieldForm.value.value) ? this.customFieldForm.value.value : [];
        if (status) {
            values.push(option);
        } else {
            if (values.indexOf(option) !== -1) {
                values.splice(values.indexOf(option.id), 1);
            }
        }
        this.customFieldForm.get('value').patchValue(values);
        this.customFieldForm.markAsDirty();
    }
}
